// tslint:disable
// interface ICompanyProp {
//     name: string
// }

export interface ICompany {
    id: number
    labels: string[],
    props: {
        name: string
    }
}

export interface IProps {
    name: string
    id?: number
    relId?: number
    currency?: 'US' | 'GBP' | 'RMB' | 'HK' | 'O' | 'N/A'
    sum?: number
    [propName: string]: any,
}

export interface IAggregationProp extends IProps {
    id: number
    currency: 'US' | 'GBP' | 'RMB' | 'HK' | 'O' | 'N/A'
    sum: number
    [propName: string]: any
}

export interface INode {
    id: number
    labels: string[]
    props: IProps
    visible: boolean
    [propName: string]: any
}

export interface ILink {
    id?: number
    type: string
    start: INode
    end: INode
    props: IProps
}

export interface IRelationship {
    id: number
    type: string
    props: any
    start: INode
    end: INode
}

export interface IStyle {
    color: string
    color_hover?: string
    color_label?: string
    icon?: string
    icon_group?: string
}

export const NODE_STYLE = {
    HKEX: {
        color: '#F4364C',
        icon: 'group',
        icon_group: 'group',
    },
    PARTA: {
        color: '#13426B',
        icon: 'company1',
        icon_group: 'company',
    },
    PARTB: {
        color: '#FFB81C',
        icon: 'company1',
        icon_group: 'company',
    },
    DEFAULT: {
        color: '#FFB81C',
        icon: 'company1',
        icon_group: 'company',
    },
}

export const LINK_STYLE = {
    OWN: {
        color: '#13426B',
        color_hover: 'rgba(106, 198, 255, 0.5)',
        color_label: '#2194FF',
    },
    CONTRACT: {
        color: '#F4364C',
        color_hover: 'rgba(106, 198, 255, 0.5)',
        color_label: 'red',
    },
    DEFAULT: {
        color: '#F4364C',
        color_hover: 'rgba(106, 198, 255, 0.5)',
        color_label: 'rgb(0,0,0)',
    },
}
